(() => {
  class MxStoryVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('.mx-story-video__toggle');

      if (!this.video || !this.toggle) return;

      this.mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.mediaQuery.matches;
      this.isNearViewport = false;

      this.handleToggle = () => {
        this.activate();

        if (this.video.paused) {
          this.userPaused = false;
          this.play();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      };

      this.handlePlay = () => this.updateToggle(false);
      this.handlePause = () => this.updateToggle(true);
      this.handleMotionPreference = (event) => {
        if (event.matches) {
          this.userPaused = true;
          this.video.pause();
        }
      };
      this.handleVisibility = () => {
        if (document.hidden) {
          this.video.pause();
        } else if (this.isNearViewport && !this.userPaused && !this.mediaQuery.matches) {
          this.play();
        }
      };

      this.toggle.addEventListener('click', this.handleToggle);
      this.video.addEventListener('play', this.handlePlay);
      this.video.addEventListener('pause', this.handlePause);
      this.mediaQuery.addEventListener?.('change', this.handleMotionPreference);
      document.addEventListener('visibilitychange', this.handleVisibility);

      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.isNearViewport = entry.isIntersecting;

          if (!entry.isIntersecting) {
            this.video.pause();
            return;
          }

          this.activate();
          if (!this.userPaused && !this.mediaQuery.matches) this.play();
        },
        { rootMargin: '600px 0px' }
      );
      this.observer.observe(this);
      this.updateToggle(true);
    }

    activate() {
      if (this.dataset.loaded === 'true') return;

      if (this.video.dataset.src) {
        this.video.src = this.video.dataset.src;
        this.video.removeAttribute('data-src');
      }

      this.video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });

      this.dataset.loaded = 'true';
      this.video.load();
    }

    play() {
      if (!this.isNearViewport) return;

      const playPromise = this.video.play();
      playPromise?.catch(() => this.updateToggle(true));
    }

    updateToggle(isPaused) {
      const action = isPaused ? 'Play' : 'Pause';
      const videoLabel = this.video.getAttribute('aria-label') || 'product story video';

      this.toggle.setAttribute('aria-label', `${action} ${videoLabel}`);
      this.toggle.dataset.state = isPaused ? 'paused' : 'playing';
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.toggle?.removeEventListener('click', this.handleToggle);
      this.video?.removeEventListener('play', this.handlePlay);
      this.video?.removeEventListener('pause', this.handlePause);
      this.mediaQuery?.removeEventListener?.('change', this.handleMotionPreference);
      document.removeEventListener('visibilitychange', this.handleVisibility);
    }
  }

  if (!customElements.get('mx-story-video')) {
    customElements.define('mx-story-video', MxStoryVideo);
  }
})();
